import { USER_ROLE } from '@/types/user-profile'
import Service, { getCallApiFunction } from '../service'

type ParamsType = {
  data: {
    followeeId: string
    followeeType: USER_ROLE
    followerId: string
    followerType: USER_ROLE
  }
}
type ResponseType = {
  isSuccess: boolean
}
class AddFollowingApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.config = {
      url: '/v1/livemall/member/follow',
      method: 'POST',
      data: params.data,
    }
  }
}
export const addFollowingMember = async (params: ParamsType): Promise<ResponseType> => getCallApiFunction(new AddFollowingApi(params))
